import { CourseApiDto } from '@lx/shared/api/models';

export type DurationUnit = CourseApiDto.DurationUnitEnum;
export const DurationUnitEnum = CourseApiDto.DurationUnitEnum;
